import { BaseEntity, ObjType } from "./BaseEntity";

/** ロックステータス */
export const LOCK_STATUS: ObjType = {
  "0": "正常",
  "1": "管理者によるロック",
  "2": "パスワードロック",
};

/** MFA認証実施可否 */
export const IS_MFAAUTH: ObjType = { 
  true: "実施する", 
  false: "実施しない" 
};

/** テナント都合によるロック */
export const TENANT_LOCK: ObjType = {
  false: "-",
  true: "ロック",
};

/** アカウント種類(アクセス権限) */
export const ACCESS_AUTH: ObjType = {
  0: "MDMのみ",
  1: "MDM + 回ポ",
};

/**
 * ユーザー(mdm_user)
 */
export class MdmUser extends BaseEntity {
  /** ユーザーID */
  public id: string = "";
  /** ユーザー名 */
  public username: string = "";
  /** 表示用ユーザー名 */
  public displayName: string = "";
  /** パスワード */
  public password: string = "";
  /** メールアドレス */
  public email: string = "";
  /** アカウントの種類 */
  public accessAuth: number = 0;
  /** ロール */
  public roleCd: string = "";
  /** アカウント有効期限 */
  public expireDate: Date = new Date();
  /** 氏名 */
  public fullName: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 組織ID */
  public orgId: string = "";
  /** コメント */
  public comment: string = "";
  /** ロックステータス */
  public lockStatus: string = "";
  /** ロック日時 */
  public lockDate: string = "";
  /** パスワード誤り回数 */
  public passfailCount: number = 0;
  /** MFA認証実施可否 */
  public isMfaauth: boolean = true;
  /** ユーザーレベル */
  public userLevel: number = 0;
  /** 最終ログイン日時 */
  public lastloginDate: string = "";
}
